import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import { keysToCamel } from '@utils/butter';

import { IPageProps } from '@folx-types/flow-steps';

import MedicationDeliveryPostSubmitPreferredPharmacyStep, {
	IMedicationDeliveryPostSubmitPreferredPharmacyStepPageContent,
} from './MedicationDeliveryPostSubmitPreferredPharmacyStep.component';

interface IMedicationDeliveryPostSubmitPreferredPharmacyStepPageProps extends IPageProps {}

const MedicationDeliveryPostSubmitPreferredPharmacyStepPage: FC<
	IMedicationDeliveryPostSubmitPreferredPharmacyStepPageProps
> = ({ path }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(
				slug: { eq: "medication-delivery-post-submit-step-preferred-pharmacy" }
			) {
				heading
				confirmation_message
				cta
			}
		}
	`);

	const refinedContent: IMedicationDeliveryPostSubmitPreferredPharmacyStepPageContent = keysToCamel(
		pageContent
	) as IMedicationDeliveryPostSubmitPreferredPharmacyStepPageContent;

	return (
		<MedicationDeliveryPostSubmitPreferredPharmacyStep pageContent={refinedContent} path={path} />
	);
};

export default MedicationDeliveryPostSubmitPreferredPharmacyStepPage;
